import Cookies from "js-cookie";

export const state = {
  token: Cookies.get("token_cabinet"),
  username: Cookies.get("username_cabinet"),
  settings: {}
};

export const getters = {
  isAuthenticated: state => !!state.token,
  authToken: state => state.token,
  getUsername: state => state.username,
  getAuthSettings: state => state.settings
};

export default {
  state,
  getters
};
